// extracted by mini-css-extract-plugin
module.exports = {"share-project-dialog":"ProjectShareDialog_share-project-dialog__Nf3o7","footer":"ProjectShareDialog_footer__8x1jm"};